<script setup lang="ts">
import { ref } from "vue";
import { __color } from "@zyzgroup/core-web";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    text?: string;
    textSize?: number;
    borderColor?: string;
    borderWidth?: number;
    borderRadius?: number;
  }>(),
  {
    text: "",
    textSize: 12,
    borderColor: "#5a82f0",
    borderWidth: 2,
    borderRadius: 8
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

const isFocus = ref(false);
const start = () => {
  isFocus.value = true;
};
const end = () => {
  isFocus.value = false;
};

defineExpose({ start, end });
</script>

<template>
  <Box
    class="border-focus-text"
    display-type="shrink"
  >
    <div
      class="text"
      v-if="isFocus"
      :style="{
        fontSize: `${textSize}px`,
        top: `${-Math.ceil(textSize / 2) - 4}px`,
        padding: '4px 12px',
        backgroundColor: borderColor,
        borderRadius: `${textSize}px 0 ${textSize}px 0`,
        color: __color
          .set(borderColor)
          .opposite(true, '#333333', '#ffffff')
          .toString()
      }"
    >
      {{ props.text }}
    </div>
    <div
      class="inner"
      :style="{
        border: `${borderWidth}px solid ${
          isFocus ? borderColor : 'transparent'
        }`,
        borderRadius: `${borderRadius}px`
      }"
    >
      <slot></slot>
    </div>
  </Box>
</template>

<style scoped>
.text {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.inner {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
